"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../../index");
/**
 * OUI vertical navigation component.
 *
 * @oui-component VerticalNavItem
 */
// Internally we are using Tabs here so that we can reuse the index tracking logic for selection.
// But vertical nav doesn't mean to be vertical Tab.
// They have the similar menu section, but vertical nav doesn't come with content panel.
var VerticalNavItem = /** @class */ (function (_super) {
    __extends(VerticalNavItem, _super);
    function VerticalNavItem(props) {
        return _super.call(this, props) || this;
    }
    VerticalNavItem.prototype.render = function () {
        return React.createElement(index_1.Tab, __assign({}, this.props));
    };
    return VerticalNavItem;
}(React.Component));
exports.default = VerticalNavItem;
//# sourceMappingURL=VerticalNavItem.js.map